<template>
  <BfFlex
    align="center"
    class="selection-details-item"
  >
    <BfIcon
      :icon="icon"
      :size="Sizes.xxl"
      :type="IconType.Contained"
      :contained-padding="Sizes.xxs"
    />

    <span
      ><b>{{ label }}:</b> {{ value }}</span
    >
  </BfFlex>
</template>

<script setup lang="ts">
import { BfFlex, BfIcon, IconType, Sizes } from '@finetic/bikefitting-ui'

defineProps<{
  icon?: string
  label: string
  value: string
}>()
</script>

<style lang="scss">
.selection-details-item {
}
</style>
